// AGC: Admin themed table wrapper — uppercase micro headers, hover rows, themed borders
import React from 'react'

interface AdminTableProps {
  children: React.ReactNode
  className?: string
}

export const AdminTable: React.FC<AdminTableProps> = ({ children, className = '' }) => (
  <div className={`overflow-x-auto ${className}`}>
    <table className="w-full border-collapse text-sm">{children}</table>
  </div>
)

export const AdminThead: React.FC<{ children: React.ReactNode }> = ({ children }) => (
  <thead>
    <tr className="bg-slate-50 dark:bg-white/[0.02]">
      {children}
    </tr>
  </thead>
)

export const AdminTh: React.FC<React.ThHTMLAttributes<HTMLTableCellElement>> = ({
  children,
  className = '',
  ...props
}) => (
  <th
    className={`
      text-left px-4 py-3 text-[10px] font-semibold uppercase tracking-wider
      text-slate-400 dark:text-slate-500 ${className}
    `.replace(/\s+/g, ' ').trim()}
    {...props}
  >
    {children}
  </th>
)

export const AdminTd: React.FC<React.TdHTMLAttributes<HTMLTableCellElement>> = ({
  children,
  className = '',
  ...props
}) => (
  <td
    className={`
      px-4 py-3 text-slate-700 dark:text-slate-300
      border-t border-slate-100 dark:border-white/5 ${className}
    `.replace(/\s+/g, ' ').trim()}
    {...props}
  >
    {children}
  </td>
)

export const AdminTr: React.FC<React.HTMLAttributes<HTMLTableRowElement>> = ({
  children,
  className = '',
  ...props
}) => (
  <tr
    className={`hover:bg-slate-50/50 dark:hover:bg-white/[0.02] transition-colors ${className}`}
    {...props}
  >
    {children}
  </tr>
)
